// Expanded enemy roster - 2 acts, mid-boss + final boss.

export const ENEMIES = {
  goblincoded: {
    id: 'goblincoded', name: 'GOBLINCORE ANDY', maxHp: 22, tierMin: 1, tierMax: 2,
    sprite: 'GOB',
    intents: [
      { type: 'attack', value: 5, label: 'BONK' },
      { type: 'attack', value: 3, hits: 2, label: '2x BONK' },
      { type: 'block',  value: 6, label: 'HIDE' },
    ],
  },
  chatter: {
    id: 'chatter', name: 'DOOMSCROLL BOT', maxHp: 28, tierMin: 1, tierMax: 3,
    sprite: 'BOT',
    intents: [
      { type: 'attack', value: 7, label: 'REPLY GUY' },
      { type: 'buff', buff: 'strength', value: 2, label: 'RATIO+' },
      { type: 'attack', value: 4, hits: 2, label: 'SPAM' },
    ],
  },
  meme: {
    id: 'meme', name: 'DEEPFRIED MEME', maxHp: 34, tierMin: 2, tierMax: 3,
    sprite: 'MEM',
    intents: [
      { type: 'attack', value: 10, label: 'GRRR' },
      { type: 'debuff', debuff: 'vulnerable', value: 2, label: 'RATIO' },
      { type: 'block', value: 8, label: 'IRONIC' },
    ],
  },
  gremlin: {
    id: 'gremlin', name: 'DISCORD GREMLIN', maxHp: 18, tierMin: 1, tierMax: 2,
    sprite: 'GRM',
    intents: [
      { type: 'attack', value: 4, label: 'PING' },
      { type: 'attack', value: 6, label: 'REPLY' },
      { type: 'debuff', debuff: 'weak', value: 2, label: 'MUTE' },
    ],
  },
  cringe: {
    id: 'cringe', name: 'CRINGE LORD', maxHp: 42, tierMin: 3, tierMax: 5,
    sprite: 'CRG',
    intents: [
      { type: 'attack', value: 12, label: 'CRINGE' },
      { type: 'buff', buff: 'strength', value: 3, label: 'FLEX' },
      { type: 'attack', value: 6, hits: 2, label: 'DOUBLE L' },
      { type: 'block', value: 10, label: 'SHIELD' },
    ],
  },
  // Act 1 mid tier / act 2 fodder
  npc: {
    id: 'npc', name: 'NPC WOJAK', maxHp: 38, tierMin: 5, tierMax: 8,
    sprite: 'NPC',
    intents: [
      { type: 'attack', value: 9, hits: 2, label: 'MONOLOGUE' },
      { type: 'debuff', debuff: 'weak', value: 2, label: 'DRONE' },
      { type: 'block', value: 12, label: 'STARE' },
      { type: 'attack', value: 14, label: 'SNAP' },
    ],
  },
  edater: {
    id: 'edater', name: 'E-DATER', maxHp: 46, tierMin: 6, tierMax: 9,
    sprite: 'EDT',
    intents: [
      { type: 'attack', value: 8, hits: 2, label: 'DM STORM' },
      { type: 'debuff', debuff: 'vulnerable', value: 2, label: 'PARA-SOCIAL' },
      { type: 'buff', buff: 'strength', value: 3, label: 'DELUSION' },
    ],
  },
  // Act 2 harder mobs
  crypto_bro: {
    id: 'crypto_bro', name: 'CRYPTO BRO', maxHp: 62, tierMin: 10, tierMax: 16,
    sprite: 'BRO',
    intents: [
      { type: 'attack', value: 16, label: 'RUG PULL' },
      { type: 'buff', buff: 'strength', value: 4, label: 'MOON' },
      { type: 'attack', value: 8, hits: 2, label: 'HODL' },
      { type: 'block', value: 14, label: 'DIAMOND HANDS' },
    ],
  },
  ai_slop: {
    id: 'ai_slop', name: 'GPT SLOP', maxHp: 55, tierMin: 10, tierMax: 18,
    sprite: 'AI',
    intents: [
      { type: 'attack', value: 6, hits: 3, label: 'HALLUCINATE' },
      { type: 'debuff', debuff: 'weak', value: 3, label: 'GASLIGHT' },
      { type: 'block', value: 12, label: 'REFUSE' },
      { type: 'attack', value: 20, label: 'JAILBREAK' },
    ],
  },
  // ---- ELITES ----
  elite_influencer: {
    id: 'elite_influencer', name: 'MICRO-INFLUENCER', maxHp: 68, isElite: true,
    sprite: 'INF',
    intents: [
      { type: 'attack', value: 14, label: 'BRAND DEAL' },
      { type: 'buff', buff: 'strength', value: 3, label: 'GROWTH' },
      { type: 'attack', value: 8, hits: 2, label: 'SPONSOR' },
      { type: 'debuff', debuff: 'weak', value: 2, label: 'GATEKEEP' },
    ],
  },
  elite_algorithm: {
    id: 'elite_algorithm', name: 'THE ALGORITHM', maxHp: 82, isElite: true,
    sprite: 'ALG',
    intents: [
      { type: 'attack', value: 18, label: 'PUSH' },
      { type: 'block', value: 14, label: 'FILTER' },
      { type: 'attack', value: 6, hits: 3, label: 'FEED' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'SHADOW' },
    ],
  },
  elite_troll: {
    id: 'elite_troll', name: 'THE TROLL', maxHp: 92, isElite: true, act: 2,
    sprite: 'TRL',
    intents: [
      { type: 'attack', value: 22, label: 'BAIT' },
      { type: 'attack', value: 10, hits: 2, label: 'FLAME' },
      { type: 'buff', buff: 'strength', value: 4, label: 'EDGE' },
      { type: 'block', value: 18, label: 'BLOCK LIST' },
    ],
  },
  elite_bot_farm: {
    id: 'elite_bot_farm', name: 'BOT FARM', maxHp: 110, isElite: true, act: 2,
    sprite: 'FRM',
    intents: [
      { type: 'attack', value: 6, hits: 5, label: '5x REPLIES' },
      { type: 'debuff', debuff: 'weak', value: 3, label: 'REPORTED' },
      { type: 'block', value: 22, label: 'SCALE' },
      { type: 'attack', value: 24, label: 'MASS DM' },
    ],
  },
  // ---- BOSSES ----
  boss_slop: {
    id: 'boss_slop', name: 'THE SLOP LORD', maxHp: 130, isBoss: true, isMidBoss: true,
    sprite: 'SLOP',
    intents: [
      { type: 'attack', value: 22, label: 'SLOPWAVE' },
      { type: 'block', value: 18, label: 'GLOOP' },
      { type: 'attack', value: 8, hits: 3, label: 'DRIP DRIP DRIP' },
      { type: 'buff', buff: 'strength', value: 4, label: 'RATIOMAX' },
      { type: 'debuff', debuff: 'weak', value: 2, label: 'MOG' },
    ],
  },
  boss_final: {
    id: 'boss_final', name: 'THE FINAL ARC', maxHp: 220, isBoss: true, isFinal: true,
    sprite: 'ARC',
    intents: [
      { type: 'attack', value: 30, label: 'CANON EVENT' },
      { type: 'attack', value: 12, hits: 3, label: 'RETCON' },
      { type: 'block', value: 30, label: 'PLOT ARMOR' },
      { type: 'buff', buff: 'strength', value: 6, label: 'MAIN CHARACTER' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'DEUS EX' },
      { type: 'debuff', debuff: 'weak', value: 3, label: 'FLASHBACK' },
    ],
  },
  // ==================== v0.7 - THE DISCORD SERVER BIOME (Act 2) ====================
  discord_mod: {
    id: 'discord_mod', name: 'DISCORD MOD', maxHp: 58, tierMin: 10, tierMax: 18,
    sprite: 'MOD',
    intents: [
      { type: 'attack', value: 14, label: 'BAN HAMMER' },
      { type: 'debuff', debuff: 'weak', value: 3, label: 'TIMEOUT' },
      { type: 'block', value: 16, label: 'MOD SHIELD' },
      { type: 'attack', value: 7, hits: 2, label: 'DM WARNING' },
    ],
  },
  discord_pinger: {
    id: 'discord_pinger', name: 'PINGER', maxHp: 48, tierMin: 10, tierMax: 15,
    sprite: 'PNG',
    intents: [
      { type: 'attack', value: 4, hits: 4, label: '@EVERYONE' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'DM SPAM' },
      { type: 'attack', value: 12, label: 'BUMP' },
    ],
  },
  discord_lurker: {
    id: 'discord_lurker', name: 'LURKER', maxHp: 72, tierMin: 12, tierMax: 20,
    sprite: 'LRK',
    intents: [
      { type: 'block', value: 22, label: 'HIDE' },
      { type: 'buff', buff: 'strength', value: 5, label: 'READ RECEIPTS' },
      { type: 'attack', value: 26, label: 'AMBUSH' },
    ],
  },
  discord_nitro: {
    id: 'discord_nitro', name: 'NITRO BOOSTER', maxHp: 66, tierMin: 11, tierMax: 18,
    sprite: 'NTR',
    intents: [
      { type: 'attack', value: 18, label: 'PAY-TO-WIN' },
      { type: 'block', value: 12, label: 'BOOST' },
      { type: 'buff', buff: 'strength', value: 3, label: 'SHOWOFF' },
    ],
  },
  discord_janny: {
    id: 'discord_janny', name: 'UNPAID JANNY', maxHp: 50, tierMin: 10, tierMax: 16,
    sprite: 'JNY',
    intents: [
      { type: 'attack', value: 8, hits: 2, label: 'CLEAN CHAT' },
      { type: 'debuff', debuff: 'weak', value: 2, label: 'SHUT UP' },
      { type: 'block', value: 10, label: 'STRUGGLE' },
    ],
  },
  discord_edater2: {
    id: 'discord_edater2', name: 'FEMBOY MOD', maxHp: 55, tierMin: 11, tierMax: 17,
    sprite: 'FBM',
    intents: [
      { type: 'attack', value: 6, hits: 3, label: 'UWU-PUNCH' },
      { type: 'debuff', debuff: 'vulnerable', value: 2, label: 'PARASOCIAL' },
      { type: 'buff', buff: 'strength', value: 4, label: 'DELULU' },
    ],
  },

  // ---- v0.7 - NEW ELITES WITH GIMMICKS ----
  elite_summoner: {
    id: 'elite_summoner', name: 'CHAIN SUMMONER', maxHp: 78, isElite: true, act: 2,
    sprite: 'SUM',
    intents: [
      { type: 'attack', value: 5, hits: 3, label: 'SUMMON x3' },
      { type: 'buff', buff: 'strength', value: 3, label: 'RITUAL' },
      { type: 'attack', value: 14, label: 'CHAIN HEX' },
      { type: 'block', value: 16, label: 'CIRCLE' },
    ],
  },
  elite_mirror: {
    id: 'elite_mirror', name: 'MIRROR MIMIC', maxHp: 65, isElite: true,
    sprite: 'MIR',
    intents: [
      { type: 'attack', value: 12, label: 'MIRROR' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'REFLECT-DEBUFF' },
      { type: 'block', value: 20, label: 'GLASS' },
      { type: 'attack', value: 8, hits: 2, label: 'SHATTER' },
    ],
  },

  // ---- v0.7 - NEW MULTI-PHASE BOSSES ----
  // Multi-phase intents live in `phases` array; engine swaps `intents` on threshold.
  boss_algorithm: {
    id: 'boss_algorithm', name: 'THE ALGORITHM', maxHp: 180, isBoss: true, isMidBoss: true,
    sprite: 'ALG',
    intents: [
      { type: 'attack', value: 18, label: 'RECOMMEND' },
      { type: 'block', value: 20, label: 'SHADOWBAN' },
    ],
    phases: [
      { threshold: 1.0, intents: [
        { type: 'attack', value: 18, label: 'RECOMMEND' },
        { type: 'block', value: 20, label: 'SHADOWBAN' },
        { type: 'debuff', debuff: 'vulnerable', value: 2, label: 'DEMOTE' },
      ] },
      { threshold: 0.6, intents: [
        { type: 'attack', value: 8, hits: 3, label: 'AUTOPLAY' },
        { type: 'buff', buff: 'strength', value: 4, label: 'GO VIRAL' },
        { type: 'attack', value: 25, label: 'FYP CANNON' },
      ] },
      { threshold: 0.25, intents: [
        { type: 'attack', value: 14, hits: 3, label: 'DOOM FEED' },
        { type: 'attack', value: 40, label: 'DEATH SCROLL' },
        { type: 'debuff', debuff: 'weak', value: 4, label: 'BURNOUT' },
      ] },
    ],
  },
  boss_ai_god: {
    id: 'boss_ai_god', name: 'GPT-INFINITY', maxHp: 260, isBoss: true, isFinal: true,
    sprite: 'GPT',
    intents: [
      { type: 'attack', value: 22, label: 'TOKENIZE' },
      { type: 'block', value: 28, label: 'REFUSE' },
    ],
    phases: [
      { threshold: 1.0, intents: [
        { type: 'attack', value: 22, label: 'TOKENIZE' },
        { type: 'block', value: 28, label: 'REFUSE' },
        { type: 'debuff', debuff: 'weak', value: 3, label: 'CENSOR' },
      ] },
      { threshold: 0.65, intents: [
        { type: 'attack', value: 10, hits: 4, label: 'HALLUCINATE' },
        { type: 'buff', buff: 'strength', value: 5, label: 'FINETUNE' },
        { type: 'block', value: 22, label: 'GUARDRAIL' },
      ] },
      { threshold: 0.3, intents: [
        { type: 'attack', value: 45, label: 'JAILBREAK PROMPT' },
        { type: 'debuff', debuff: 'vulnerable', value: 4, label: 'INJECT' },
        { type: 'attack', value: 15, hits: 3, label: 'SLOP CASCADE' },
      ] },
    ],
  },
  boss_chad_supreme: {
    id: 'boss_chad_supreme', name: 'CHAD SUPREME', maxHp: 210, isBoss: true, isFinal: true,
    sprite: 'CHD',
    intents: [
      { type: 'attack', value: 20, label: 'MOG' },
      { type: 'block', value: 25, label: 'FLEX' },
    ],
    phases: [
      { threshold: 1.0, intents: [
        { type: 'attack', value: 20, label: 'MOG' },
        { type: 'block', value: 25, label: 'FLEX' },
        { type: 'buff', buff: 'strength', value: 3, label: 'PROTEIN' },
      ] },
      { threshold: 0.55, intents: [
        { type: 'attack', value: 14, hits: 2, label: 'DOUBLE MOG' },
        { type: 'buff', buff: 'strength', value: 5, label: 'CREATINE' },
        { type: 'attack', value: 30, label: 'GIGA CHAD SLAM' },
      ] },
      { threshold: 0.2, intents: [
        { type: 'attack', value: 50, label: 'FINAL FORM' },
        { type: 'debuff', debuff: 'weak', value: 4, label: 'HUMILIATE' },
      ] },
    ],
  },

  // ==================== v0.8 - FYP TIMELINE (Act 3) BIOME ====================
  fyp_deepfake: {
    id: 'fyp_deepfake', name: 'DEEPFAKE', maxHp: 62, tierMin: 15, tierMax: 22,
    sprite: 'DF!',
    intents: [
      { type: 'attack', value: 15, label: 'MIMIC' },
      { type: 'debuff', debuff: 'vulnerable', value: 4, label: 'UNCANNY' },
      { type: 'block', value: 18, label: 'FADE' },
    ],
  },
  fyp_doomscroller: {
    id: 'fyp_doomscroller', name: 'DOOMSCROLLER', maxHp: 82, tierMin: 15, tierMax: 22,
    sprite: 'DMS',
    intents: [
      { type: 'attack', value: 6, hits: 3, label: 'DOOM FEED' },
      { type: 'debuff', debuff: 'weak', value: 3, label: 'DESPAIR' },
      { type: 'buff', buff: 'strength', value: 4, label: 'RAGE' },
    ],
  },
  fyp_brainrot_supreme: {
    id: 'fyp_brainrot_supreme', name: 'BRAINROT SUPREME', maxHp: 90, tierMin: 16, tierMax: 22,
    sprite: 'BRS',
    intents: [
      { type: 'attack', value: 22, label: 'INFOHAZARD' },
      { type: 'debuff', debuff: 'weak', value: 3, label: 'SKIBIDI' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'GYATT' },
      { type: 'attack', value: 10, hits: 2, label: 'RIZZ TAX' },
    ],
  },
  fyp_aura_farmer: {
    id: 'fyp_aura_farmer', name: 'AURA FARMER', maxHp: 70, tierMin: 15, tierMax: 20,
    sprite: 'AUR',
    intents: [
      { type: 'buff', buff: 'strength', value: 6, label: 'AURA UP' },
      { type: 'attack', value: 20, label: 'AURA POINT' },
      { type: 'block', value: 24, label: 'AURA WALL' },
    ],
  },
  fyp_edater3: {
    id: 'fyp_edater3', name: 'MASK-ON EDATER', maxHp: 74, tierMin: 15, tierMax: 20,
    sprite: 'MSK',
    intents: [
      { type: 'attack', value: 12, hits: 2, label: 'LOVEBOMB' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'GHOSTED' },
      { type: 'attack', value: 24, label: 'BLOCK+DELETE' },
    ],
  },
  fyp_kpop_stan: {
    id: 'fyp_kpop_stan', name: 'K-POP STAN', maxHp: 66, tierMin: 15, tierMax: 20,
    sprite: 'KPS',
    intents: [
      { type: 'attack', value: 5, hits: 4, label: 'CHOREOGRAPHY' },
      { type: 'buff', buff: 'strength', value: 3, label: 'BIAS PICK' },
      { type: 'block', value: 15, label: 'FANCAM' },
    ],
  },
  fyp_thirst_trap: {
    id: 'fyp_thirst_trap', name: 'THIRST TRAP', maxHp: 60, tierMin: 15, tierMax: 20,
    sprite: 'THR',
    intents: [
      { type: 'debuff', debuff: 'weak', value: 4, label: 'DISTRACTION' },
      { type: 'attack', value: 18, label: 'DM SLIDE' },
      { type: 'block', value: 16, label: 'SIMP TAX' },
    ],
  },
  fyp_ragebaiter: {
    id: 'fyp_ragebaiter', name: 'RAGEBAITER', maxHp: 78, tierMin: 16, tierMax: 22,
    sprite: 'RGB',
    intents: [
      { type: 'attack', value: 14, label: 'HOT TAKE' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'REPLY GUY' },
      { type: 'buff', buff: 'strength', value: 5, label: 'ENGAGEMENT' },
    ],
  },

  // v0.8: Mini-bosses (multi-phase, appear on new mini-boss floor at F14 optional)
  miniboss_algo_v2: {
    id: 'miniboss_algo_v2', name: 'FOR YOU PAGE', maxHp: 130, isMidBoss: true,
    sprite: 'FYP',
    intents: [
      { type: 'attack', value: 12, hits: 2, label: 'DOOM FEED' },
      { type: 'block', value: 18, label: 'MUTE' },
    ],
    phases: [
      { threshold: 1.0, intents: [
        { type: 'attack', value: 12, hits: 2, label: 'DOOM FEED' },
        { type: 'block', value: 18, label: 'MUTE' },
      ] },
      { threshold: 0.5, intents: [
        { type: 'attack', value: 26, label: 'AUTOPLAY BOMB' },
        { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'HIDE' },
      ] },
    ],
  },
  miniboss_ratio_lord: {
    id: 'miniboss_ratio_lord', name: 'RATIO LORD', maxHp: 145, isMidBoss: true,
    sprite: 'RAT',
    intents: [
      { type: 'attack', value: 16, label: 'RATIO' },
      { type: 'buff', buff: 'strength', value: 3, label: 'REPLIES' },
    ],
    phases: [
      { threshold: 1.0, intents: [
        { type: 'attack', value: 16, label: 'RATIO' },
        { type: 'buff', buff: 'strength', value: 3, label: 'REPLIES' },
        { type: 'block', value: 14, label: 'BLOCK EVERYONE' },
      ] },
      { threshold: 0.4, intents: [
        { type: 'attack', value: 6, hits: 5, label: 'MASS RATIO' },
        { type: 'debuff', debuff: 'weak', value: 4, label: 'CANCELLED' },
      ] },
    ],
  },

  // ==================== v1.3 MORE SLOP - 8 new enemies + Cursed Emoji Lord secret boss ====================
  // Act 1 additions
  gyatt_gremlin: {
    id: 'gyatt_gremlin', name: 'GYATT GREMLIN', maxHp: 16, tierMin: 1, tierMax: 2,
    sprite: 'GYT',
    intents: [
      { type: 'attack', value: 4, label: 'BONK' },
      { type: 'debuff', debuff: 'vulnerable', value: 1, label: 'GYATT!' },
      { type: 'block', value: 4, label: 'BOWSER' },
    ],
  },
  ohio_goblin: {
    id: 'ohio_goblin', name: 'OHIO GOBLIN', maxHp: 24, tierMin: 1, tierMax: 3,
    sprite: 'OHO',
    intents: [
      { type: 'attack', value: 6, label: 'OHIO' },
      { type: 'attack', value: 3, hits: 2, label: 'DOUBLE OHIO' },
      { type: 'buff', buff: 'strength', value: 1, label: 'RIZZ UP' },
    ],
  },
  skibidi_thug: {
    id: 'skibidi_thug', name: 'SKIBIDI THUG', maxHp: 30, tierMin: 2, tierMax: 4,
    sprite: 'SKB',
    intents: [
      { type: 'attack', value: 8, label: 'SKIBIDI' },
      { type: 'debuff', debuff: 'weak', value: 1, label: 'CRINGE OUT' },
      { type: 'attack', value: 5, hits: 2, label: 'TOILET DASH' },
    ],
  },
  // Act 2 additions
  live_streamer: {
    id: 'live_streamer', name: 'LIVE STREAMER', maxHp: 44, tierMin: 6, tierMax: 12,
    sprite: 'LIV',
    intents: [
      { type: 'attack', value: 10, label: 'HYPE' },
      { type: 'buff', buff: 'strength', value: 3, label: 'RAID CHANNEL' },
      { type: 'attack', value: 5, hits: 3, label: 'DONO SPAM' },
      { type: 'block', value: 12, label: 'MOD ARMY' },
    ],
  },
  crypto_shill: {
    id: 'crypto_shill', name: 'CRYPTO SHILL', maxHp: 50, tierMin: 7, tierMax: 14,
    sprite: '₿',
    intents: [
      { type: 'attack', value: 12, label: 'RUG PULL' },
      { type: 'debuff', debuff: 'vulnerable', value: 3, label: 'HYPE POST' },
      { type: 'block', value: 15, label: 'DIAMOND HANDS' },
      { type: 'attack', value: 4, hits: 3, label: 'ALT COINS' },
    ],
  },
  onlyfools_gooner: {
    id: 'onlyfools_gooner', name: 'ONLY FOOLS GOONER', maxHp: 40, tierMin: 6, tierMax: 12,
    sprite: 'OFG',
    intents: [
      { type: 'attack', value: 9, label: 'THIRST' },
      { type: 'debuff', debuff: 'weak', value: 3, label: 'PARASOCIAL' },
      { type: 'buff', buff: 'strength', value: 2, label: 'DELUSION' },
    ],
  },
  // Act 3 additions
  ai_thumbnail: {
    id: 'ai_thumbnail', name: 'AI THUMBNAIL', maxHp: 62, tierMin: 12, tierMax: 20,
    sprite: 'AIT',
    intents: [
      { type: 'attack', value: 14, label: 'RED ARROW' },
      { type: 'debuff', debuff: 'vulnerable', value: 4, label: 'CLICKBAIT' },
      { type: 'attack', value: 7, hits: 2, label: 'FACE ZOOM' },
      { type: 'buff', buff: 'strength', value: 4, label: 'ALGORITHM' },
    ],
  },
  hyperslop_influencer: {
    id: 'hyperslop_influencer', name: 'HYPERSLOP INFLUENCER', maxHp: 74, tierMin: 14, tierMax: 22,
    sprite: 'HSI',
    intents: [
      { type: 'attack', value: 16, label: 'PROMO' },
      { type: 'attack', value: 6, hits: 3, label: 'TRIPLE POST' },
      { type: 'debuff', debuff: 'weak', value: 4, label: 'PARA' },
      { type: 'block', value: 18, label: 'DELETE CTRL Z' },
    ],
  },

  // 🎃 SECRET BOSS — CURSED EMOJI LORD 🎃
  // Reached via a rare (~15%) roll in getFinalBoss OR via seed containing "CURSED"
  boss_cursed_emoji: {
    id: 'boss_cursed_emoji', name: 'THE CURSED EMOJI LORD', maxHp: 280, isBoss: true, isFinal: true, secret: true,
    sprite: '💀',
    phases: [
      { threshold: 1.0, intents: [
        { type: 'attack', value: 22, label: '💀 SKULL' },
        { type: 'attack', value: 6, hits: 4, label: '🌀 SPIRAL' },
        { type: 'debuff', debuff: 'vulnerable', value: 4, label: '👁 GAZE' },
        { type: 'block', value: 28, label: '🩻 XRAY' },
      ] },
      { threshold: 0.66, intents: [
        { type: 'attack', value: 14, hits: 3, label: '🥶 FREEZE X3' },
        { type: 'debuff', debuff: 'weak', value: 4, label: '🫠 MELT' },
        { type: 'buff', buff: 'strength', value: 5, label: '🩸 BLOODRAGE' },
        { type: 'attack', value: 32, label: '🔥 IGNITE' },
      ] },
      { threshold: 0.33, intents: [
        { type: 'attack', value: 10, hits: 5, label: '🕳 VOID X5' },
        { type: 'debuff', debuff: 'vulnerable', value: 6, label: '🤡 CLOWNCORE' },
        { type: 'attack', value: 40, label: '🧠 BRAINDRAIN' },
      ] },
    ],
  },
};

const ACT1_NORMAL = ['goblincoded','chatter','meme','gremlin','cringe','npc','edater','gyatt_gremlin','ohio_goblin','skibidi_thug'];
const ACT2_NORMAL = ['cringe','npc','edater','crypto_bro','ai_slop','discord_mod','discord_pinger','discord_lurker','discord_nitro','discord_janny','discord_edater2','live_streamer','crypto_shill','onlyfools_gooner'];
const ACT3_NORMAL = ['fyp_deepfake','fyp_doomscroller','fyp_brainrot_supreme','fyp_aura_farmer','fyp_edater3','fyp_kpop_stan','fyp_thirst_trap','fyp_ragebaiter','ai_thumbnail','hyperslop_influencer'];

export function pickEnemyForFloor(rng, floor) {
  let pool;
  if (floor < 11) pool = ACT1_NORMAL.filter(id => {
    const e = ENEMIES[id];
    return floor >= (e.tierMin ?? 1) && floor <= (e.tierMax ?? 99);
  });
  else if (floor < 16) pool = ACT2_NORMAL;
  else pool = ACT3_NORMAL;
  const id = pool[Math.floor(rng() * pool.length)];
  const enemy = { ...ENEMIES[id] };
  // Scale HP by act
  if (floor > 10 && floor < 16) enemy.maxHp = Math.floor(enemy.maxHp * 1.35);
  else if (floor >= 16) enemy.maxHp = Math.floor(enemy.maxHp * 1.55);
  return enemy;
}

// v0.8 / v3.3: Elite modifier ("affix") system. Now applies from floor 6+ or ascension 2+.
// Each affix is a distinct behavioral trait that changes tactics.
export const ELITE_AFFIXES = {
  vampiric:    { name: 'VAMPIRIC',    desc: 'Heals 30% of dmg dealt.',                     color: '#ff2b2b', apply: (e) => { e.vampiric = 0.3; e.name = 'VAMPIRIC ' + e.name; } },
  enraged:     { name: 'ENRAGED',     desc: '+3 STR at start.',                            color: '#ff6600', apply: (e) => { e.strength = (e.strength || 0) + 3; e.name = 'ENRAGED ' + e.name; } },
  cursed:      { name: 'CURSED',      desc: 'Applies extra WEAK on hit.',                  color: '#ff007f', apply: (e) => { e.applyExtraWeak = 2; e.name = 'CURSED ' + e.name; } },
  explosive:   { name: 'EXPLOSIVE',   desc: 'Deals 12 dmg to you on death.',               color: '#ffd700', apply: (e) => { e.deathBomb = 12; e.name = 'EXPLOSIVE ' + e.name; } },
  armored:     { name: 'ARMORED',     desc: 'Starts with 30 block.',                       color: '#00e5ff', apply: (e) => { e.startBlock = 30; e.name = 'ARMORED ' + e.name; } },
  swift:       { name: 'SWIFT',       desc: '+30% max HP + 20% dmg.',                      color: '#39ff14', apply: (e) => { e.maxHp = Math.floor(e.maxHp * 1.3); e.dmgMult = 1.2; e.name = 'SWIFT ' + e.name; } },
  // v3.3 additions
  regenerating:{ name: 'REGENERATING',desc: 'Regenerates 5 HP each of its turns.',         color: '#39ff14', apply: (e) => { e.regenPerTurn = 5; e.name = 'REGENERATING ' + e.name; } },
  barbed:      { name: 'BARBED',      desc: 'Reflects 3 dmg back to you on each hit taken.',color: '#c084fc',apply: (e) => { e.barbedThorns = 3; e.name = 'BARBED ' + e.name; } },
  doubled:     { name: 'DOUBLED',     desc: 'Attack intent damage +50%.',                  color: '#ff2ea6', apply: (e) => { e.doubledIntent = 1.5; e.name = 'DOUBLED ' + e.name; } },
  shielded:    { name: 'SHIELDED',    desc: 'Immune to first 8 damage each turn.',         color: '#7dd3fc', apply: (e) => { e.perTurnShield = 8; e.name = 'SHIELDED ' + e.name; } },
  // v3.4 additions
  poisonous:   { name: 'POISONOUS',   desc: 'Applies +2 POISON on each attack.',           color: '#84cc16', apply: (e) => { e.applyPoisonOnHit = 2; e.name = 'POISONOUS ' + e.name; } },
  mimic:       { name: 'MIMIC',       desc: '+20% max HP · gives a random card on death.',color: '#a855f7', apply: (e) => { e.maxHp = Math.floor(e.maxHp * 1.2); e.mimicReward = true; e.name = 'MIMIC ' + e.name; } },
  livestreamed:{ name: 'LIVE-STREAMED',desc:'Drops DOUBLE gold + tokens.',                  color: '#ff2ea6', apply: (e) => { e.livestreamed = true; e.name = 'LIVE-STREAMED ' + e.name; } },
  chained:     { name: 'CHAINED',     desc: '+50% max HP + +2 STR each turn.',             color: '#f97316', apply: (e) => { e.maxHp = Math.floor(e.maxHp * 1.5); e.strengthPerTurn = 2; e.name = 'CHAINED ' + e.name; } },
};

export function pickEliteForFloor(rng, floor, ascension = 0) {
  let pool;
  if (floor < 11) pool = [ENEMIES.elite_influencer, ENEMIES.elite_algorithm, ENEMIES.elite_mirror];
  else if (floor < 16) pool = [ENEMIES.elite_troll, ENEMIES.elite_bot_farm, ENEMIES.elite_summoner, ENEMIES.elite_mirror];
  else pool = [ENEMIES.elite_troll, ENEMIES.elite_bot_farm, ENEMIES.elite_summoner, ENEMIES.elite_mirror, ENEMIES.elite_algorithm];
  const enemy = { ...pool[Math.floor(rng() * pool.length)] };
  if (enemy.phases) enemy.phases = enemy.phases.map(p => ({ ...p, intents: [...p.intents] }));
  // v3.3: Affix rolls from floor 6+ or ascension 2+. Higher floors + ascension = higher chance.
  const affixChance = ascension >= 2 ? 0.7 : (floor >= 6 ? 0.45 : 0);
  if (rng() < affixChance) {
    const affixIds = Object.keys(ELITE_AFFIXES);
    const affixId = affixIds[Math.floor(rng() * affixIds.length)];
    ELITE_AFFIXES[affixId].apply(enemy);
    enemy.affix = affixId;
  }
  return enemy;
}

// Mid-boss pool - random between original and Algorithm (multi-phase)
export function getMidBoss(rng) {
  const pool = [ENEMIES.boss_slop, ENEMIES.boss_algorithm, ENEMIES.miniboss_algo_v2, ENEMIES.miniboss_ratio_lord];
  const pick = rng ? pool[Math.floor(rng() * pool.length)] : ENEMIES.boss_slop;
  const enemy = { ...pick };
  if (enemy.phases) enemy.phases = enemy.phases.map(p => ({ ...p, intents: [...p.intents] }));
  return enemy;
}

export function getFinalBoss(rng, seed = '') {
  // v1.3: Cursed Emoji Lord — secret boss triggers on 15% roll OR seed contains 'CURSED'
  const seedTriggered = typeof seed === 'string' && seed.toUpperCase().includes('CURSED');
  if (seedTriggered || (rng && rng() < 0.15)) {
    const enemy = { ...ENEMIES.boss_cursed_emoji };
    if (enemy.phases) enemy.phases = enemy.phases.map(p => ({ ...p, intents: [...p.intents] }));
    return enemy;
  }
  const pool = [ENEMIES.boss_final, ENEMIES.boss_ai_god, ENEMIES.boss_chad_supreme];
  const pick = rng ? pool[Math.floor(rng() * pool.length)] : ENEMIES.boss_final;
  const enemy = { ...pick };
  if (enemy.phases) enemy.phases = enemy.phases.map(p => ({ ...p, intents: [...p.intents] }));
  return enemy;
}

export function getBoss() { return ENEMIES.boss_slop; } // legacy
